import { CdkDrag } from "@angular/cdk/drag-drop";
import { Component, ViewChild } from "@angular/core";
import { GlobalHelpDialogComponent } from "@comunicare/comunicare-dashboard-modals";
import { WidgetName } from "@comunicare/comunicare-interfaces";
import { HelpData } from "src/app/helpers/helpData";
import { IWidgetComponent } from "src/app/models/widget.interface";
import { ResponsiveDialogService } from "src/app/providers/responsive-dialog.service";

@Component({
  selector: "app-patient-alert-orange-widget",
  templateUrl: "./patient-alert-orange-widget.component.html",
  styleUrls: ["./patient-alert-orange-widget.component.scss"],
})
export class PatientAlertOrangeWidgetComponent implements IWidgetComponent {
  @ViewChild(CdkDrag, { static: true }) cdkDrag: CdkDrag;
  public isDraggable = true;
  public widgetName = WidgetName.PATIENT_ALERT_ORANGE;

  constructor(private responsiveDialog: ResponsiveDialogService, public helpData: HelpData) {}

  public openOrangeAlertHelp(): void {
    this.responsiveDialog.open(
      GlobalHelpDialogComponent,
      {
        data: { slides: this.helpData.patientsOrangeAlert },
        disableClose: true,
      },
      { maxWidth: "80vw" }
    );
  }
}
